module.exports = __webpack_public_path__ + "static/media/toolbar-show-hide-area.4a2a4eb1.svg";